import { render } from "./Farm.vue?vue&type=template&id=7097c8aa"
import script from "./Farm.vue?vue&type=script&lang=js"
export * from "./Farm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Farm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7097c8aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7097c8aa', __exports__)) {
    api.reload('7097c8aa', __exports__)
  }
  
  module.hot.accept("./Farm.vue?vue&type=template&id=7097c8aa", () => {
    api.rerender('7097c8aa', render)
  })

}


export default __exports__